module.exports = __webpack_public_path__ + "img/itx-file-type-xml.2049e9ae.svg";